import Platform from "../../../libs/utility/Platform";

export default {
    onboardingStepContainer: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        alignItems: "center",
    },
    formDiv: {
        width: Platform.isMobileView() ? "100%" : "700px",
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
}